import { CHART_TYPE_LABELS, genreOptions, PLATFORM_LABELS, useMeta } from '../../hooks/useMeta'
import { Segmented } from '../Segmented'

export interface MoversFilter {
	platform: string
	storefront: string
	/** Empty = every category. */
	genre: string
	/** Empty = every chart type. */
	type: string
	window: '24h' | '7d'
	kind: 'gainers' | 'losers' | 'new'
}

export function MoversFilters({ value, onChange }: { value: MoversFilter; onChange(v: MoversFilter): void }) {
	const { data: meta } = useMeta()
	return (
		<div className="row">
			<Segmented
				label="Movement"
				value={value.kind}
				options={[
					{ value: 'gainers', label: 'Gainers' },
					{ value: 'losers', label: 'Losers' },
					{ value: 'new', label: 'New' },
				]}
				onChange={(kind) => onChange({ ...value, kind })}
			/>
			<Segmented
				label="Window"
				value={value.window}
				options={[
					{ value: '24h', label: '24h' },
					{ value: '7d', label: '7d' },
				]}
				onChange={(window) => onChange({ ...value, window })}
			/>
			<Segmented
				label="Platform"
				value={value.platform}
				options={['iphone', 'ipad', 'mac', 'appletv', 'watch'].map((p) => ({ value: p, label: PLATFORM_LABELS[p] }))}
				onChange={(platform) => onChange({ ...value, platform, genre: '' })}
			/>
			<select
				aria-label="Country"
				value={value.storefront}
				onChange={(e) => onChange({ ...value, storefront: e.target.value })}
			>
				{meta?.storefronts.map((s) => (
					<option key={s.code} value={s.code}>
						{s.name}
					</option>
				))}
			</select>
			<select aria-label="Category" value={value.genre} onChange={(e) => onChange({ ...value, genre: e.target.value })}>
				<option value="">Every chart</option>
				{genreOptions(meta, value.platform).map((g) => (
					<option key={g.id} value={g.id}>
						{g.label}
					</option>
				))}
			</select>
			<select aria-label="Chart type" value={value.type} onChange={(e) => onChange({ ...value, type: e.target.value })}>
				<option value="">Free, paid &amp; grossing</option>
				{Object.entries(CHART_TYPE_LABELS).map(([t, label]) => (
					<option key={t} value={t}>
						{label}
					</option>
				))}
			</select>
		</div>
	)
}
